export const EMBEDDED_WALLET_PATH = "/sdk/2022-08-12/embedded-wallet";
export const HEADLESS_GOOGLE_OAUTH_ROUTE = `${EMBEDDED_WALLET_PATH}/auth/headless-google-login-managed`;

export const WALLET_USER_DETAILS_LOCAL_STORAGE_NAME = (clientId: string) =>
  `paperEwsWalletUserDetails-${clientId}`;
export const WALLET_USER_ID_LOCAL_STORAGE_NAME = (clientId: string) =>
  `paperEwsWalletUserId-${clientId}`;
const AUTH_TOKEN_LOCAL_STORAGE_PREFIX = "walletToken";
export const AUTH_TOKEN_LOCAL_STORAGE_NAME = (clientId: string) => {
  return `${AUTH_TOKEN_LOCAL_STORAGE_PREFIX}-${clientId}`;
};
const DEVICE_SHARE_LOCAL_STORAGE_PREFIX = "a";
export const DEVICE_SHARE_LOCAL_STORAGE_NAME = (
  clientId: string,
  userId: string,
) => `${DEVICE_SHARE_LOCAL_STORAGE_PREFIX}-${clientId}-${userId}`;
export const DEVICE_SHARE_LOCAL_STORAGE_NAME_DEPRECATED = (clientId: string) =>
  `${DEVICE_SHARE_LOCAL_STORAGE_PREFIX}-${clientId}`;
